module.exports = __webpack_public_path__ + "img/footer-logo.7887081e.png";